export const submitUserAccountRequest_actionType = {
    SUBMIT_ACTION_SUCCESS : 'SUBMIT_ACTION_SUCCESS',
    SUBMIT_ACTION_FAILURE : 'SUBMIT_ACTION_FAILURE'
};